/**
 * Row kebab menu — thin wrapper over DropdownMenu/IconButton. Not in
 * design_system_export's spec set — composed from existing primitives, same
 * precedent as SortableTh/ConfirmDialog. Extracted after UsersPage and
 * OrganizationsPage each independently hand-rolled a byte-identical
 * page-scoped copy.
 *
 * @param {Array} items - DropdownMenu items
 * @param {boolean=false} disabled
 */
import React from "react";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import IconButton from "../IconButton/IconButton";
import Icon from "../icons/Icon";

const RowActionsMenu = ({ items, disabled }) => {
  const trigger = (
    <IconButton
      size="md"
      variant="ghost"
      icon={<Icon name="DotsVertical" size={20} />}
      label="More options"
      disabled={disabled}
    />
  );

  return <DropdownMenu trigger={trigger} items={items} align="end" />;
};

export default RowActionsMenu;
